const lockersState = {
    allLockers: undefined,
    requestingAllLockers: false,
    requestingSiteLockers: false,
    siteLockers: undefined
};
export default lockersState;
